const dns_select_template_dialog = {
	autocomplete: {
		label: "DNS template",
	},
	description:
		"Select an existing DNS template whose DNS records you want to use. The selected DNS records are added to the current DNS records list. The DNS records currently in the template will therefore not be overwritten by the selected DNS records",
	submit_button: {
		label: "Add ({{record_selected_count}} records)",
	},
	success_message: "The DNS templates have been successfully added.",
	title: "Select DNS-template",
};

export default dns_select_template_dialog;
